import { useState } from "react";
import './LazyImage.css';

const LazyImage = ({
    src,
    alt,
    className = '',
    ...props
}: any) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <>
            {loaded ? (
                <img
                    src={src}
                    alt={alt}
                    className={`${className}`}
                    onLoad={() => setLoaded(true)}
                    {...props}
                />
            ) : (
                <div className={`lazy-image-wrapper `}>
                    <img
                        src={src}
                        alt={alt}
                        className={`lazy-image loading`}
                        onLoad={() => setLoaded(true)}
                        {...props}
                    />
                </div>
            )}
        </>

    );
};

export default LazyImage;